<template>
  <page-template>
    <div class="toolbar">
      <button @click="exportStoreCSV">이마트24 매장 정보 csv로 받기(DB 업데이트 없음)</button>
      <!-- 2020년 3월31일 여대표 요청으로 일괄발행과 정지를 막음 -->
      <!-- <button style="margin-left:8px;" class="ui button primary" @click="enableAll(true)">일괄발행</button>
      <button style="margin-left:8px;" class="ui button negative" @click="enableAll(false)">일괄발행정지</button>-->
      <!-- <input type="checkbox" id="checkbox" v-model="check_sms_permitted">
      <label for="checkbox">SMS 동의</label>-->
    </div>

    <board
      :is-fold="isFold"
      :http-options="httpOptions"
      :config="config"
      :insert-row-function="() => insertRow('createEmptyAddress')"
      :disabled-play-button="true"
    />
    <!-- <board
      :is-fold="isFold"
      :http-options="httpOptions"
      :config="config"
      :insert-row-function="() => insertRow('createEmptyAddress')"
      :delete-row-function="(rows) => deleteRow('deleteAddresses', rows)"
      :disabled-play-button="true"
    />-->
  </page-template>
</template>

<script>
import Vue from "vue";

import config from "./Config";
import Editor from "./detail-row/OfflineStoreManageEditor";
import CommonBoardItems from "../CommonBoardItems";
import axios from "axios";

Vue.component(config.detailRowComponentName, Editor);

export default {
  name: "BoardOfflineStoreManage",
  mixins: [CommonBoardItems],
  data() {
    return {
      config
    };
  },
  methods: {
    async exportStoreCSV() {
      this.$store.commit("showLoading");
      console.dir(this.httpOptions);
      let myOptions = JSON.parse(JSON.stringify(this.httpOptions));
      delete myOptions.params.per_page;
      const response = await axios.get("/api/addresses_csv", myOptions);
      console.log("response", response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.headers.filename);
      document.body.appendChild(link);
      link.click();
      this.$store.commit("hideLoading");
    },
    async enableAll(value) {
      this.$store.commit("showLoading");
      let myOptions = JSON.parse(JSON.stringify(this.httpOptions));
      myOptions.params.enable = value;
      const response = await axios.get("/api/addresses_enable", myOptions);
      this.$store.commit("hideLoading");
      // console.log("response:", response);
      this.$toast(response.data.message);
      this.config.apiUrl = "";
      this.$nextTick(() => {
        this.config.apiUrl = "/api/addresses";
      });
    }
  }
};
</script>

<style>
.toolbar {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}
.toolbar > input,
button {
  margin-left: 20px;
}
.toolbar > label {
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/address/BoardOfflineStoreManage.vue